"use client"

import { useState, useRef, useEffect } from "react"
import "./Faq.css"

const Faq = () => {
  const sectionRef = useRef(null)

  const faqs = [
    {
      id: 1,
      question: "What minimum order quantities do you require?",
      answer:
        "Our minimum order quantities vary by product type. For standard products, we typically require a minimum order of 1,000 units. For custom products, the minimum order quantity may be higher depending on the complexity of the design and manufacturing process. Please contact our sales team for specific information about your product of interest.",
    },
    {
      id: 2,
      question: "Can you create custom-sized packaging?",
      answer:
        "Yes, we specialize in creating custom-sized packaging solutions tailored to your specific requirements. Our engineering team can work with you to design and manufacture packaging in custom dimensions, shapes, and configurations. Please provide your specifications when requesting a quote.",
    },
    {
      id: 3,
      question: "What printing options do you offer for tin cans?",
      answer:
        "We offer a wide range of printing options for tin cans, including offset lithography, digital printing, and embossing. We can print in full color with high-resolution images, metallic inks, matte or glossy finishes, and special coatings. Our team can help you select the best printing method based on your design requirements and budget.",
    },
    {
      id: 4,
      question: "How long does it take to fulfill an order?",
      answer:
        "Standard products typically ship within 2-3 weeks from order confirmation. Custom products may take 4-8 weeks depending on complexity, design approval, and production scheduling. Rush orders may be accommodated for an additional fee, subject to production capacity.",
    },
    {
      id: 5,
      question: "Do you ship internationally?",
      answer:
        "Yes, we ship our products worldwide. International shipping costs and delivery times vary based on destination, order volume, and shipping method. Our logistics team can provide you with shipping options and estimated delivery times for your specific location.",
    },
    {
      id: 6,
      question: "What materials do you use for your packaging products?",
      answer:
        "We use high-quality tinplate, aluminum, and food-grade plastics for our packaging products. All our materials comply with relevant industry standards and regulations. We also offer eco-friendly options for environmentally conscious customers.",
    },
  ]

  const [openFaq, setOpenFaq] = useState(null)

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id)
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
          }
        })
      },
      { threshold: 0.1 },
    )

    const animatedElements = sectionRef.current.querySelectorAll(".animate-in")
    animatedElements.forEach((el) => observer.observe(el))

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el))
    }
  }, [])

  return (
    <div className="faq" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center animate-in">Frequently Asked Questions</h2>
        <p className="faq-subtitle text-center animate-in">
          Find answers to common questions about our products and services
        </p>

        <div className="faq-container animate-in">
          {faqs.map((faq) => (
            <div className={`faq-item ${openFaq === faq.id ? "open" : ""}`} key={faq.id}>
              <div className="faq-question" onClick={() => toggleFaq(faq.id)}>
                <h3>{faq.question}</h3>
                <span className="faq-icon"></span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-cta text-center animate-in">
          <h3>Still have questions?</h3>
          <p>Our team is ready to assist you with any additional questions you may have.</p>
          <a href="#contact" className="btn">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  )
}

export default Faq
